import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/Auth.module";
import UserModule from "./modules/User.module";
import ConfigModule from "./modules/Config.module";
import LotteryModule from "./modules/Lottery.module";
import ClientModule from "./modules/Client.module";
import CardModule from "./modules/Card.module";
import PackageModule from "./modules/Package.module";
import MediaModule from "./modules/Media.module";


Vue.use(Vuex);

const modules = {
    AuthModule,
    UserModule,
    ConfigModule,
    LotteryModule,
    ClientModule,
    CardModule,
    MediaModule,
    PackageModule
};

const store = new Vuex.Store({
    state: {
        loading: false,
        barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
        barImage: "https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg",
        drawer: null,
    },
    modules,
    mutations: {
        SET_BAR_IMAGE(state, payload) {
            state.barImage = payload;
        },
        SET_DRAWER(state, payload) {
            state.drawer = payload;
        },
    },
});
export default store;

export const config = function (key, value) {
    store.commit(ConfigModule.types.SET, {key, value});
};

export function getModule(moduleName) {
    return modules[moduleName];
}
